const ATN_PREFIX = "atn::";
const ITEMS_PREFIX = "/items/";

export function parseTaxonomyIdFromUrl(pathname: string): string {
  const suffix = pathname.includes(ITEMS_PREFIX)
    ? pathname.substring(pathname.indexOf(ITEMS_PREFIX) + ITEMS_PREFIX.length)
    : pathname;
  return suffix.startsWith(ATN_PREFIX) ? suffix : `${ATN_PREFIX}${suffix}`;
}

export function getTaxonomyPath(taxonomyId: string): string {
  return taxonomyId.startsWith(ATN_PREFIX) ? taxonomyId.substring(ATN_PREFIX.length) : taxonomyId;
}
